import {
  PersonAddress,
  PersonWithCorrespondence,
} from "views/ProcessDetails/refactor/types/process.types";

const EMPTY_CORRESPONDENCE = "-";

export const getAddressCorrespondences = (
  addresses: PersonAddress[] | undefined,
) =>
  addresses
    ?.map((address) => address?.correspondence?.trim())
    .filter((address): address is string => Boolean(address)) ?? [];

export const getPrimaryCorrespondence = (
  addresses: PersonAddress[] | undefined,
) => {
  const correspondences = getAddressCorrespondences(addresses);

  if (correspondences.length === 0) {
    return EMPTY_CORRESPONDENCE;
  }

  const mainAddress = addresses?.find((address) => address?.main === 1);

  return mainAddress?.correspondence?.trim() || correspondences[0];
};

export const getCorrespondenceModalContent = (
  person: Pick<PersonWithCorrespondence, "addresses"> | null | undefined,
) => {
  const correspondences = getAddressCorrespondences(person?.addresses);

  if (correspondences.length > 0) {
    return correspondences.join("\n\n");
  }

  return EMPTY_CORRESPONDENCE;
};

export const getCorrespondenceModalItems = (
  person: Pick<PersonWithCorrespondence, "addresses"> | null | undefined,
) => {
  const correspondences = getAddressCorrespondences(person?.addresses);

  if (correspondences.length > 0) {
    return correspondences;
  }

  return [EMPTY_CORRESPONDENCE];
};
